import { adminTranslations } from './adminTranslations';

// Traduzione del pannello amministratore. La chiave è il testo italiano:
// per l'italiano ta() lo restituisce così com'è, per le altre lingue cerca la
// traduzione in adminTranslations e, se manca, ripiega sull'italiano (mai una
// chiave vuota o un errore). La lingua corrente è una variabile di modulo
// impostata da AdminAuthGate prima di ogni render: quando cambia, lo stato
// dell'utente cambia e tutto l'albero del pannello viene ridisegnato.
export const ADMIN_LANGUAGE_KEYS = ['it', 'en', 'ro'];

const LOCALES = { it: 'it-IT', en: 'en-GB', ro: 'ro-RO' };

let current = 'it';

export function setAdminLang(lang) {
  current = ADMIN_LANGUAGE_KEYS.includes(lang) ? lang : 'it';
}

export function getAdminLang() {
  return current;
}

// Per toLocaleDateString / toLocaleString ecc.
export function adminLocale() {
  return LOCALES[current] || LOCALES.it;
}

export function ta(key) {
  if (current === 'it') return key;
  return adminTranslations[current]?.[key] ?? key;
}

// Come ta(), ma sostituisce i segnaposto {nome} con i valori dati.
// Esempio: taf('Eliminare "{nome}"?', { nome: contact.nome })
export function taf(key, vars = {}) {
  let text = ta(key);
  Object.keys(vars).forEach((k) => { text = text.split(`{${k}}`).join(String(vars[k] ?? '')); });
  return text;
}

// Ultima lingua usata in questo browser: serve alle schermate prima del login
// (accesso, recupero password) dove l'utente non è ancora identificato.
const STORAGE_KEY = 'exelflow_admin_lang';

export function loadStoredAdminLang() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return ADMIN_LANGUAGE_KEYS.includes(v) ? v : 'it';
  } catch {
    return 'it';
  }
}

export function storeAdminLang(lang) {
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // archiviazione non disponibile: la lingua resta comunque quella dell'account
  }
}
